import React, {useState, useEffect, useCallback} from 'react'
import { Bar } from 'react-chartjs-2';
import restaurantListHe from './../../../restaurants/restaurantsListHe'

function BestRest({getDateFormat, statistics}) {
    let [properRest, setproperRest] = useState(statistics)
    const [, updateState] = React.useState(); // To force render
    const forceUpdate = useCallback(() => updateState({}), []); // Force render

    useEffect(() => {
        if (window.location.href.includes('/en')) return;
        // If the page is on Hebrew, set all restaurant titles to Hebrew ones
        for (let i=0; i<properRest.length; i++) {
            for (let z = 0; z < properRest[i].bestRest.length; z++) {
                properRest[i].bestRest[z].name = restaurantListHe[z].title;
            }
            console.log(properRest);
        }
        setproperRest(properRest);
        forceUpdate();
    }, [])

    let getLabels = (bestRest) => {
        let arr = [];
        bestRest.map((obj) => {
            arr.push(obj.name);
        });
        return arr;
    }
    let getCounters = (bestRest) => {
        let arr = [];
        bestRest.map((obj) => {
            arr.push(obj.counter);
        });
        return arr;
    }

    let getData = (bestRest) => {
        return {
            labels: getLabels(bestRest),
            datasets: [
                {
                    label: (window.location.href.includes('/en')) ? 'Amount of sells' : 'כמות מכירות',
                    data: getCounters(bestRest),
                    backgroundColor: ['rgba(255,104,0,0.6)', 'rgb(124,255,0,0.6)', 'rgb(255,0,0,0.6)', 'rgb(178,0,255,0.6)', 'rgb(66,255,0,0.6)', 'rgb(255,0,158,0.6)'],
                    borderWidth: 1,
                    borderColor: '#000'
                }
            ]
        }
    }
if (window.location.href.includes('/en')) {
    return (
        <div className="chartText">
            {properRest.map((restaurant, index) => 
                <React.Fragment key={index}>

                {index==0 ? <div className="titleChart">{getDateFormat(restaurant.timestamp)} - Now</div>
                : <div className="titleChart">{getDateFormat(statistics[index-1].timestamp)} - {getDateFormat(restaurant.timestamp)}</div>}
                <div className="containerBar">
                    <Bar
                    data={getData(restaurant.bestRest)}                       
                    options={{ 
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false }}
                    />
                </div>

                </React.Fragment>
            )}
        </div>     
    )
}

// Else render it in Hebrew
    return (
        <div className="chartText">
            {properRest.map((restaurant, index) => 
                <React.Fragment key={index}>

                {index==0 ? <div className="titleChart">{getDateFormat(restaurant.timestamp)} - עכשיו</div>
                : <div className="titleChart">{getDateFormat(statistics[index-1].timestamp)} - {getDateFormat(restaurant.timestamp)}</div>}
                <div className="containerBar">
                    <Bar
                    data={getData(restaurant.bestRest)}                       
                    options={{ 
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false }}
                    />
                </div>

                </React.Fragment>
            )}
        </div>
    )
}

export default BestRest
